export const onLoadingIndicator = (show) => {
    return new CustomEvent('onLoadingIdicator', { detail: show });
};
